import React, { Fragment } from 'react';
import { Editor } from 'draft-js';

const EditorNoControls = ( { editorState, setEditorState, readOnly } ) => {

    return (
        <Fragment>
            <Editor
                readOnly
                editorState={ editorState }
                onChange={ setEditorState }
            />
        </Fragment>
    );
};

export default EditorNoControls;